if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.applyKineticMediaOrder();
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    applyKineticMediaOrder() {
      const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
      if (!match) return;

      const ordering = {"precision":{"variants":["37100975620396","32748211929388"],"editorial":"44329175810348"},"mnml":{"variants":["34520043618604","34520040472876","34520040505644","34520040440108","34520040538412"],"editorial":"44329157722412"},"enigma":{"variants":["38685714383148","35787305287980","35787304370476","35787302830380","35787300962604","40611120382252","41115246133548","42279319404844"],"editorial":"44329135112492"},"femme":{"variants":["36972891373868","36383792300332","36383790629164","36383788171564"],"editorial":"44329136357676"},"artesian":{"variants":["37324869730604","37324040175916","37324853674284","37324040274220"],"editorial":"44329109750060"},"chronos":{"variants":["38981451546924","38981451088172","38981451710764"],"editorial":"44329109160236"},"aegis":{"variants":["39040776241452","39021492371756","39021492338988"],"editorial":"44329102016812"},"azure":{"variants":["39462091587884","39461977325868"],"editorial":"44329115124012"},"aero":{"variants":["39573400158508","39531556143404","39573364965676","39573364998444","39531558502700","39531557159212","39531557683500","39531559289132"],"editorial":"44329106866476"},"sonnet":{"variants":["39782465339692","39782465274156"],"editorial":"44329196847404"},"vector":{"variants":["42284696666412","40877541196076","40890344407340"],"editorial":"44329204973868"},"mirage":{"variants":["41335845519660","41335845060908","41335844798764","41335844995372","41335845126444"],"editorial":"44329152250156"},"renegade":{"variants":["42150353436972","42150612893996","42150390333740","42289775903020","42150326599980","42150326894892","42289776689452"],"editorial":"44329195143468"},"moku":{"variants":["42176184451372","42176184385836","42176184418604"],"editorial":"44329164407084"},"lumo":{"variants":["42191718121772","42191677325612","42191676932396","42191676997932","42191677030700","42191676899628","42191677129004","42191677227308","42191677292844","42191677391148"],"editorial":"44329138159916"},"maverick":{"variants":["42231952179500","42231945101612","42231945396524","42231945429292","42231945330988","42231945494828","42284483281196","42284484264236","42284485378348"],"editorial":"44329222930732"},"canvas":{"variants":["42427768013100","42427768111404","42427767947564","42427767980332","42427767914796","42427768045868"],"editorial":"44329112928556"},"genesis":{"variants":["42626352218412","42622667718956","42622667784492","42622667751724","42622667817260","42622667850028"],"editorial":"44329219785004"},"spectre":{"variants":["43724200771884","43724201230636","43724201296172"],"editorial":"44329203433772"},"echelon":{"variants":["32758268428588","44329128755500"],"editorial":"44329128788268"},"noir":{"variants":["38678337126700","44329169289516","38678360064300"],"editorial":"44329169322284"},"oceana":{"variants":["33755272446252","33011761119532","33011759808812","33011760234796"],"editorial":"44329173418284"}};
      const productOrder = ordering[match[1]];
      if (!productOrder) return;

      const viewerList = this.elements.viewer && this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
      if (!viewerList) return;

      const activeNode = viewerList.querySelector('.is-active[data-media-id]');
      const activeKeyMatch = activeNode && activeNode.getAttribute('data-media-id').match(/(\d+)$/);
      const activeKey = activeKeyMatch ? activeKeyMatch[1] : null;
      const preferredKeys = [
        activeKey,
        ...productOrder.variants.filter((id) => id !== activeKey),
        productOrder.editorial
      ].filter(Boolean);

      const reorder = (container, attribute) => {
        if (!container) return;
        const nodes = Array.from(container.children).filter((node) => node.hasAttribute(attribute));
        const preferredNodes = preferredKeys
          .map((id) => nodes.find((node) => (node.getAttribute(attribute) || '').endsWith('-' + id)))
          .filter(Boolean);
        const remainingNodes = nodes.filter((node) => !preferredNodes.includes(node));
        [...preferredNodes, ...remainingNodes].forEach((node) => container.appendChild(node));
      };

      reorder(viewerList, 'data-media-id');

      if (this.elements.thumbnails) {
        const thumbnailList = this.elements.thumbnails.querySelector('[id^="Slider-Thumbnails"]');
        reorder(thumbnailList, 'data-target');
      }
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
